/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type GripperTypeEnum = 'Standard 1 section' | 'Standard 2 section, 1 generation' | 'Standard 2 section, 2 generation' | 'Standard 3 InLine' | 'Standard quad pick, 4 zones' | 'Standard quad pick, 6 zones' | 'Custom Gripper';

export const GripperTypeEnum = {
    STANDARD_1_SECTION: 'Standard 1 section' as GripperTypeEnum,
    STANDARD_2_SECTION_1_GENERATION: 'Standard 2 section, 1 generation' as GripperTypeEnum,
    STANDARD_2_SECTION_2_GENERATION: 'Standard 2 section, 2 generation' as GripperTypeEnum,
    STANDARD_3_INLINE: 'Standard 3 InLine' as GripperTypeEnum,
    STANDARD_QUAD_PICK_4_ZONES: 'Standard quad pick, 4 zones' as GripperTypeEnum,
    STANDARD_QUAD_PICK_6_ZONES: 'Standard quad pick, 6 zones' as GripperTypeEnum,
    CUSTOM_GRIPPER: 'Custom Gripper' as GripperTypeEnum
};

